import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { TokenStorageService } from '@services/token-storage.service';

function extractToken(body: unknown): string | null {
  if (!body || typeof body !== 'object') {
    return null;
  }
  const token = (body as { token?: unknown }).token;
  return typeof token === 'string' && token.trim() ? token.trim() : null;
}

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorage = inject(TokenStorageService);
  const token = tokenStorage.getToken();
  // Never attach Bearer to static SPA assets (i18n JSON, images, help docs).
  const isStaticAsset =
    req.url.startsWith('/assets/') ||
    req.url.includes('/assets/');
  const authReq =
    token && !isStaticAsset && !req.headers.has('Authorization')
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

  return next(authReq).pipe(
    tap((event) => {
      const body = (event as { body?: unknown }).body;
      const refreshed = extractToken(body);
      if (refreshed) {
        tokenStorage.refreshToken(refreshed);
      }
    }),
  );
};
